import React from 'react';
import Modal from '../../../../../components/Modal';
import Section from '../../../../../components/outline/Section';
import TableWithSummary from '../../../../../components/table/TableWithSummary';
import columns from './columns';
import { COUPON_LIST_FILTER_OPTION_MODEL } from '../../../../../store/modules/coupon/models';
import { LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';
import { COUPON_LIST_TABLE_EMPTY_TEXT } from '../../../../../constants/service/app/couponConstants';
import './SearchCouponListModal.scss';

const SearchCouponListModal = (props) => {
  const {
    isOpen,
    closeModal,
    onSubmit,
    onCheckIssuedCoupon,
    data,
    getList,
    selectedCouponList,
    toggleModal,
    getExcelDownload,
  } = props;
  const { list, filterOption, pagination, sortOption, summary } = data.listData;

  return (
    <Modal
      title="발급할 쿠폰 선택"
      isOpen={isOpen}
      width={1500}
      height={600}
      isFooter={true}
      okText="선택 완료"
      onOk={() => onSubmit()}
      onClose={() => closeModal()}
    >
      <Section className="search-coupon-list-modal" title="[발급할 쿠폰을 선택해주세요.]">
        <div className="info">
          선택된 쿠폰: <span>{selectedCouponList.length}개</span>
        </div>

        <TableWithSummary
          data={list}
          totalCnt={summary.totalCnt}
          initialOption={{
            filterOption: COUPON_LIST_FILTER_OPTION_MODEL,
            pagination: LIST_PAGINATION_MODEL,
          }}
          isStriped={true}
          emptyText={COUPON_LIST_TABLE_EMPTY_TEXT}
          showPagination
          sortOption={sortOption}
          filterOption={filterOption}
          pagination={pagination}
          getList={getList}
          getExcelDownload={getExcelDownload}
          isUsedCheckbox={true}
          checkedIdList={selectedCouponList}
          onCheck={(list) => onCheckIssuedCoupon(list)}
          maxHeight={500}
          columns={(utils) =>
            columns({
              toggleModal,
              ...utils,
            })
          }
        />
      </Section>
    </Modal>
  );
};

export default SearchCouponListModal;
